import { useAgentPanel } from '@/context/agent-panel.context';
import { useAgentContainer } from '@/context/agent-container.context';

/**
 * True when the global AI chat panel (Nami) is actually on screen — i.e. the
 * current page registered an agent module AND the panel is open. Mirrors
 * `FloatingAgentPanel`'s `panelActive`.
 *
 * Detail slide-ins use this to drop their Radix `modal` while the chat is open:
 * a modal Dialog sets `pointer-events: none` on the body and traps focus, which
 * makes the docked chat panel un-clickable / un-typeable and turns clicks into
 * it into a dismiss. Going non-modal lets the slide-in and the chat coexist
 * (the slide-in still docks left via `--agent-panel-width`, and the shared Sheet
 * still guards against the chat-panel click dismissing it).
 *
 * Must be called within the authenticated layout (where the agent providers
 * live), which is the case for every detail slide-in.
 */
export function useChatPanelActive(): boolean {
  const { isOpen } = useAgentPanel();
  const { moduleConfig } = useAgentContainer();
  return isOpen && moduleConfig !== null;
}
